<section class="entity-report-actions-wrapper">
  <button mat-button (click)="handlePrint()" matTooltip="Imprimir">
    <mat-icon class="mat-icon-lg">print</mat-icon>
  </button>
  <button mat-button (click)="handleExcel()" matTooltip="Descargar">
    <mat-icon class="mat-icon-lg">insert_drive_file</mat-icon>
  </button>
</section>
